// extracted by mini-css-extract-plugin
export var content = "_pb-1";
export var fullScreen = "_pb-0";